import { proxy } from 'valtio';

export const indexeddbStatus = proxy({
  // We always assume that indexeddb begins healthy
  healthy: true,
});

export const updateIndexeddbStatus = (healthy: boolean) => {
  indexeddbStatus.healthy = healthy;
};
